import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { InfoSvg } from './Info';

export const InfoIcon = createIcon('info', InfoSvg);
/**
 * @deprecated используйте InfoIcon
 */
export const withInfoIcon = withIcon('info', InfoSvg);
